<div class="border" *ngIf="apiLoaded$ | async">
  <google-map [options]="googleMapOptions" height="185px" width="100%">
    <map-marker
      *ngIf="googleMapOptions?.center"
      [position]="googleMapOptions.center"
      [options]="{ icon: icon }"
    ></map-marker>
  </google-map>
</div>
